module.exports = __webpack_public_path__ + "img/traffic-light-yellow.9ff82b58.svg";